import { render } from "./SubscriptionPaymentResult.vue?vue&type=template&id=10656ab5&scoped=true"
const script = {}

import "./SubscriptionPaymentResult.vue?vue&type=style&index=0&id=10656ab5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10656ab5"]])

export default __exports__